import { render } from "./m50finalMixed.vue?vue&type=template&id=56c2665f&scoped=true"
import script from "./m50finalMixed.vue?vue&type=script&lang=js"
export * from "./m50finalMixed.vue?vue&type=script&lang=js"

import "./m50finalMixed.vue?vue&type=style&index=0&id=56c2665f&lang=less&scoped=true"

import exportComponent from "D:\\00project\\36live\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56c2665f"]])

export default __exports__